import { formatTime } from '../../../utils/dateFormat';
import { formatTimeForApi } from './buildEventFormData';

const startOfToday = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

/** True when the event calendar date is before today (local time). */
export const isEventDatePast = (eventDate) => {
  if (!eventDate) return false;
  const eventDay = new Date(eventDate);
  if (Number.isNaN(eventDay.getTime())) return false;
  return eventDay < startOfToday();
};

/** Parses stored time (12h or 24h string) into a Date for pickers. */
export const parseTimeToDate = (time) => {
  const formatted = formatTimeForApi(time);
  if (!formatted) return null;

  const [hours, minutes] = formatted.split(':').map(Number);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;

  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date;
};

/** Stores picker value as 24h `HH:mm` for the API. */
export const formatTimeFromDate = (date) => {
  if (!date) return '';
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
};

/** User-facing label (e.g. "6:00 PM"). */
export const formatTimeLabel = (time) => formatTime(time) || '';

/** Formats API `startTime` / `endTime` (e.g. "18:00") for display. */
export const formatEventTimeRange = (startTime, endTime) => {
  const start = startTime ? formatTimeLabel(startTime) : '';
  const end = endTime ? formatTimeLabel(endTime) : '';
  if (start && end) return `${start} - ${end}`;
  return start || end || '';
};
